/* Lightweight client logger.
 * Silences debug/info logs in production builds, always surfaces warnings/errors.
 * Centralizes console usage so it can later be wired to a remote sink (Sentry, etc.). */
const isProd = process.env.NODE_ENV === 'production';

export const logger = {
  debug: (...args) => { if (!isProd) console.log(...args); },
  info: (...args) => { if (!isProd) console.info(...args); },
  warn: (...args) => { console.warn(...args); },
  error: (...args) => { console.error(...args); },
};

export default logger;
